<template>
  <v-col class="pa-6">
    <div v-if="!viewingGroup">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            class="input"
            label="Search..."
            prepend-inner-icon="mdi-magnify"
            rounded
            v-model="search"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-row class="ma-0 mt-4" justify="center" justify-md="start">
            <v-select
              style="max-width: 240px"
              class="input ma-0 pa-0"
              label="Status Type"
              v-model="selectedType"
              :items="statusTypes"
              rounded
              :hide-details="true"
            ></v-select>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-data-table
          no-data-text="No groups yet"
          style="width: 100%"
          :headers="headers"
          :items="filteredGroups"
          :items-per-page="10"
          class="elevation-1 ml-4 mr-8"
        >
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon
                color="#4390c0"
                @click="
                  selectedGroup = item;
                  newStatus = item.status;
                  settingStatus = true;
                "
                >mdi-pencil</v-icon
              >
            </td>
            <td>
              <v-icon
                color="#4390c0"
                @click="
                  selectedGroup = item;
                  viewingGroup = true;
                "
                >mdi-eye</v-icon
              >
            </td>
          </template>
        </v-data-table>
      </v-row>
    </div>
    <div v-if="viewingGroup">
      <GroupView
        @close="viewingGroup = false"
        :clients="clients"
        :doctors="doctors"
        :group="selectedGroup"
      />
    </div>
    <div></div>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'">
            mdi-alert-circle
          </v-icon>
          <v-icon size="96" color="green" v-if="promptType == 'success'">
            mdi-check-circle
          </v-icon>
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="black"
            dark
            depressed
            large
            style="border-radius: 24px"
            @click="promptDialog = false"
          >
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="settingStatus" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <div class="body-1 text-h6">Set Group Status</div>
        </v-card-text>

        <v-row justify="center">
          <v-select
            style="max-width: 240px"
            class="input ma-0 my-6 pa-0"
            label="Status Type"
            v-model="newStatus"
            :items="statusTypes"
            rounded
            :hide-details="true"
            clearable
          ></v-select>
        </v-row>

        <!-- Show reason field only when Denied -->
        <v-row justify="center" v-if="newStatus === 'Denied'">
          <v-col cols="12" class="d-flex justify-center">
            <v-textarea
              v-model="denialReason"
              label="Reason for Denial"
              outlined
              color="#4390c0"
              rows="3"
              auto-grow
              counter="250"
              maxlength="250"
              hide-details="auto"
              style="width: 90%; background-color: #f9fafc; border-radius: 12px"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row justify="center" class="mt-6">
          <v-btn
            color="black"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="settingStatus = false"
          >
            CANCEL
          </v-btn>
          <v-btn
            color="blue"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            @click="updateStatus"
          >
            Update
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular :size="100" color="#4390c0" indeterminate />
      </v-overlay>
    </v-row>
  </v-col>
</template>

<script>
import GroupView from "../components/GroupView.vue";

import {
  collection,
  getDocs,
  where,
  getFirestore,
  query,
  getDoc,
  doc,
  updateDoc,
  onSnapshot,
  addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      denialReason: "",
      headers: [
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Description",
          value: "groupDescription",
        },
        {
          text: "Date Created",
          value: "date",
        },
        { text: "Created By", value: "createdByEmail" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" },
      ],
      search: "",
      groups: [],
      clients: [],
      doctors: [],
      settingStatus: false,
      selectedGroup: null,
      statusTypes: ["Pending", "Approved", "Denied"],
      selectedType: "Pending",
      newStatus: "",
      promptDialog: false,
      promptMessage: "",
      promptType: "",
      viewingGroup: false,
      unsubscribeClients: null,
      unsubscribeDoctors: null,
      unsubscribeGroups: null,
    };
  },
  components: {
    GroupView,
  },
  async created() {
    let res = await this.getClients();
    let res2 = await this.getDoctors();
    let res3 = await this.getGroups();
  },
  methods: {
    getGroups() {
      try {
        this.loading = true;
        const q = query(collection(db, "groups"));

        // Subscribe to real-time updates
        this.unsubscribeGroups = onSnapshot(q, (querySnapshot) => {
          this.groups = [];

          querySnapshot.forEach((group) => {
            let tempGroup = group.data();
            tempGroup.id = group.id;

            // Format creation date
            if (tempGroup.dateCreated?.seconds) {
              tempGroup.date = new Date(tempGroup.dateCreated.seconds * 1000)
                .toISOString()
                .substring(0, 10);
            }

            // Find creator: first in clients, then in doctors
            let createdBy = this.clients.find(
              (client) => client.id === tempGroup.createdBy.userID
            );

            if (createdBy) {
              tempGroup.createdBy = createdBy;
              tempGroup.createdByName = `${createdBy.firstName} ${createdBy.lastName}`;
              tempGroup.createdByEmail = createdBy.email;
            } else {
              createdBy = this.doctors.find(
                (doctor) => doctor.id === tempGroup.createdBy.userID
              );
              if (createdBy) {
                tempGroup.createdBy = createdBy;
                tempGroup.createdByName = `${createdBy.name} ${createdBy.surname}`;
                tempGroup.createdByEmail = createdBy.email;
              }
            }

            // Default status
            if (!tempGroup.status) tempGroup.status = "Pending";

            this.groups.push(tempGroup);
          });

          if (this.$route.query.id) {
            console.log("Groups: ", this.groups);
            let groupToView = this.groups.find(
              (group) => group.id == this.$route.query.id
            );
            if (groupToView) {
              console.log("Group to view: ", groupToView);
              this.selectedGroup = groupToView;
              this.viewingGroup = true;
            }
          }

          this.loading = false;
        });
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
        this.promptMessage = "An error occurred while fetching the groups!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    getDoctors() {
      try {
        this.loading = true;
        const q = query(collection(db, "doctors"));

        // Subscribe to real-time updates
        this.unsubscribeDoctors = onSnapshot(q, (querySnapshot) => {
          this.doctors = [];

          querySnapshot.forEach((doctor) => {
            let tempDoctor = doctor.data();
            tempDoctor.id = doctor.id;

            this.doctors.push(tempDoctor);
          });

          this.loading = false;
        });
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
        this.promptMessage = "An error occurred while fetching the doctors!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    getClients() {
      try {
        const q = query(collection(db, "clients"));
        this.loading = true;

        // Subscribe to real-time updates
        this.unsubscribeClients = onSnapshot(q, (querySnapshot) => {
          this.clients = []; // Clear previous list

          querySnapshot.forEach((docSnap) => {
            const tempClient = docSnap.data();
            tempClient.id = docSnap.id;
            this.clients.push(tempClient);
          });

          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
        console.error("Error fetching clients:", error);
      }
    },
    async updateStatus() {
      if (this.newStatus === "Denied" && !this.denialReason.trim()) {
        this.promptMessage = "Please provide a reason for denial.";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      this.settingStatus = false;
      this.loading = true;

      try {
        const groupRef = doc(db, "groups", this.selectedGroup.id);
        const updateData = {
          status: this.newStatus,
          denialReason: this.newStatus === "Denied" ? this.denialReason : "",
        };

        await updateDoc(groupRef, updateData);

        // ✅ Save alert with correct userID
        const alertData = {
          createdAt: new Date(),
          message: `Group "${this.selectedGroup.name}" status updated to "${
            this.newStatus
          }"${
            this.newStatus === "Denied" ? ` — Reason: ${this.denialReason}` : ""
          }`,
          type: `Group ${this.newStatus}`,
          userID: this.selectedGroup.createdBy?.id || "Unknown",
          userType: this.selectedGroup.createdBy?.type || "Client",
        };

        await addDoc(collection(db, "alerts"), alertData);

        this.selectedGroup.status = this.newStatus;
        this.selectedGroup.denialReason = this.denialReason;
        this.loading = false;

        this.promptMessage = "Status updated successfully!";
        this.promptType = "success";
        this.promptDialog = true;

        await this.getGroups();
      } catch (error) {
        console.error("Error updating status:", error);
        this.loading = false;
        this.promptMessage =
          "Something went wrong while updating the group's status. Please try again.";
        this.promptType = "error";
        this.promptDialog = true;
      } finally {
        this.denialReason = "";
      }
    },
  },
  computed: {
    filteredGroups() {
      return this.groups.filter((item) => {
        // Filter by status if selectedStatus is not null
        const matchesStatus =
          this.selectedType === null || item.status === this.selectedType;

        // Filter by search text
        const matchesSearch = Object.values(item).some((value) => {
          if (value !== null && value !== undefined) {
            return value
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase());
          }
          return false;
        });

        // Only return items that match both filters
        return matchesStatus && matchesSearch;
      });
    },
  },
  beforeUnmount() {
    if (this.unsubscribeDoctors) {
      this.unsubscribeDoctors();
    }

    if (this.unsubscribeClients) {
      this.unsubscribeClients();
    }

    if (this.unsubscribeGroups) {
      this.unsubscribeGroups();
    }
  },
};
</script>

<style scoped>
.v-textarea textarea {
  font-size: 14px;
  line-height: 1.5;
}

.v-textarea .v-field__input {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
</style>
